import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination } from 'swiper'
import Link from 'next/link'
import {
  getCurrentPage,
  getImageNameFromURL,
  removePrecedingSlash,
} from '@framework/utils/app-util'
import { isMobileOnly } from 'react-device-detect'
import { IMG_PLACEHOLDER } from '@components/utils/textVariables'
import {
  EmptyGuid,
  PLP_BANNER_1,
  PLP_BANNER_2,
  PLP_BANNER_3,
} from '@components/utils/constants'
import IntersectionObserverComponent from '@components/utils/IntersectionObserverComponent'
import { GA_EVENT } from 'hooks/ga_event.modal'
import { recordGA4Event } from '@components/services/analytics/ga4'

interface IProps {
  productIdx: number
  user: any
  mid1Banners?: Array<any>
  mid2Banners?: Array<any>
  mid3Banners?: Array<any>
}

interface IBanner {
  current_page: string
  position: number
  banner_name: string
  component_type: string
  component_name: string
  url: string
  loggedin_status: boolean
  device: string
  mid_banner_position: number
}

export const getMidBannersHandler = (props: IProps) => {
  const { productIdx, user, mid1Banners, mid2Banners, mid3Banners } = props

  const _mid1Banners =
    mid1Banners && mid1Banners?.length > 0
      ? mid1Banners
      : [
          {
            link: '/my-account/referral',
            url: PLP_BANNER_1,
            mobileUrl: PLP_BANNER_1,
            title: 'Banner1',
          },
        ]
  const _mid2Banners =
    mid2Banners && mid2Banners?.length > 0
      ? mid2Banners
      : [
          {
            link: '/my-account/referral',
            url: PLP_BANNER_2,
            mobileUrl: PLP_BANNER_2,
            title: 'Banner2',
          },
        ]
  const _mid3Banners =
    mid3Banners && mid3Banners?.length > 0
      ? mid3Banners
      : [
          {
            link: '/my-account/referral',
            url: PLP_BANNER_3,
            mobileUrl: PLP_BANNER_3,
            title: 'Banner3',
          },
        ]

  let isOneSingleOrNot = false
  let isTwoSingleOrNot = false
  let isThreeSingleOrNot = false

  const getBannerNumber = (index: number): number => (index / 8) % 5

  const getBannerVisibility = (index: number) => {
    const bannerNumber = getBannerNumber(index)

    if (bannerNumber === 1) {
      isOneSingleOrNot = true
      isTwoSingleOrNot = false
      isThreeSingleOrNot = false
    } else if (bannerNumber === 2) {
      isOneSingleOrNot = false
      isTwoSingleOrNot = true
      isThreeSingleOrNot = false
    } else if (bannerNumber === 3) {
      isOneSingleOrNot = false
      isTwoSingleOrNot = false
      isThreeSingleOrNot = true
    } else if (bannerNumber === 4) {
      isOneSingleOrNot = true
      isTwoSingleOrNot = false
      isThreeSingleOrNot = false
    } else if (bannerNumber === 0) {
      isOneSingleOrNot = false
      isTwoSingleOrNot = true
      isThreeSingleOrNot = false
    } else {
      isOneSingleOrNot = false
      isTwoSingleOrNot = false
      isThreeSingleOrNot = true
    }
  }

  getBannerVisibility(productIdx)

  const handleBannerClickGAEvent = (banner: IBanner) => {
    recordGA4Event(window, GA_EVENT.BANNER_CLICK, banner)
  }

  if (isOneSingleOrNot) {
    return (
      <Swiper
        slidesPerView={1}
        navigation={false}
        loop={false}
        freeMode={true}
        modules={[Autoplay, Pagination]}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        className="mySwiper h-12 mt-3"
      >
        {_mid1Banners.map((banner: any, categoryidx: number) => {
          const link = banner?.link
          const webImage = banner?.url

          const mobileImage = banner?.mobileUrl
          const title = banner?.title

          const bannersData = {
            mid_banner_position: productIdx / 8,
            current_page: getCurrentPage() || '',
            position: categoryidx,
            banner_name: isMobileOnly
              ? mobileImage !== ''
                ? getImageNameFromURL(mobileImage)
                : getImageNameFromURL(webImage)
              : getImageNameFromURL(webImage),
            component_type: 'image',
            component_name:
              _mid1Banners?.length > 1 ? 'mid1-multiple' : 'mid1-single',
            loggedin_status: !!(user?.userId && user?.userId !== EmptyGuid),
            url: isMobileOnly
              ? mobileImage !== ''
                ? mobileImage
                : webImage
              : webImage,
            device: isMobileOnly ? 'Mobile' : 'Web',
          }

          return (
            <SwiperSlide
              key={`${categoryidx}`}
              onClick={() => handleBannerClickGAEvent(bannersData)}
            >
              <IntersectionObserverComponent
                title="PLP Mid Banners"
                eventName={GA_EVENT.BANNER_IMPRESSIONS}
                bannerData={bannersData}
              >
                <Link
                  legacyBehavior
                  href={`/${removePrecedingSlash(link)}`}
                  passHref
                >
                  <div className="relative flex flex-col w-full rounded">
                    <div className="relative flex-1">
                      {isMobileOnly ? (
                        <>
                          {mobileImage != '' ? (
                            <img
                              src={mobileImage || IMG_PLACEHOLDER}
                              style={{
                                width: '100%',
                              }}
                              alt={title || 'home banner'}
                              // className="h-56"
                            />
                          ) : (
                            <img
                              src={webImage || IMG_PLACEHOLDER}
                              alt={title || 'home banner'}
                            />
                          )}
                        </>
                      ) : (
                        <img
                          src={webImage || IMG_PLACEHOLDER}
                          alt={title || 'home banner'}
                        />
                      )}
                    </div>
                  </div>
                </Link>
              </IntersectionObserverComponent>
            </SwiperSlide>
          )
        })}
      </Swiper>
    )
  } else if (isTwoSingleOrNot) {
    return (
      <Swiper
        slidesPerView={1}
        navigation={false}
        loop={false}
        freeMode={true}
        modules={[Autoplay, Pagination]}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        className="mySwiper h-12 mt-3"
      >
        {_mid2Banners?.map((banner: any, categoryidx: number) => {
          const link = banner?.link
          const webImage = banner?.url

          const mobileImage = banner?.mobileUrl
          const title = banner?.title

          const bannersData = {
            mid_banner_position: productIdx / 8,
            current_page: getCurrentPage() || '',
            position: categoryidx,
            banner_name: isMobileOnly
              ? mobileImage !== ''
                ? getImageNameFromURL(mobileImage)
                : getImageNameFromURL(webImage)
              : getImageNameFromURL(webImage),
            component_type: 'image',
            component_name:
              _mid2Banners?.length > 1 ? 'mid2-multiple' : 'mid2-single',
            loggedin_status: !!(user?.userId && user?.userId !== EmptyGuid),
            url: isMobileOnly
              ? mobileImage !== ''
                ? mobileImage
                : webImage
              : webImage,
            device: isMobileOnly ? 'Mobile' : 'Web',
          }

          return (
            <SwiperSlide
              key={`${categoryidx}`}
              onClick={() => handleBannerClickGAEvent(bannersData)}
            >
              <IntersectionObserverComponent
                title="PLP Mid Banners"
                eventName={GA_EVENT.BANNER_IMPRESSIONS}
                bannerData={bannersData}
              >
                <Link
                  legacyBehavior
                  href={`/${removePrecedingSlash(link)}`}
                  passHref
                >
                  <div className="relative flex flex-col w-full rounded">
                    <div className="relative flex-1">
                      {isMobileOnly ? (
                        <>
                          {mobileImage != '' ? (
                            <img
                              src={mobileImage || IMG_PLACEHOLDER}
                              style={{
                                width: '100%',
                              }}
                              alt={title || 'home banner'}
                              // className="h-56"
                            />
                          ) : (
                            <img
                              src={webImage || IMG_PLACEHOLDER}
                              alt={title || 'home banner'}
                            />
                          )}
                        </>
                      ) : (
                        <img
                          src={webImage || IMG_PLACEHOLDER}
                          alt={title || 'home banner'}
                        />
                      )}
                    </div>
                  </div>
                </Link>
              </IntersectionObserverComponent>
            </SwiperSlide>
          )
        })}
      </Swiper>
    )
  } else if (isThreeSingleOrNot) {
    return (
      <Swiper
        slidesPerView={1}
        navigation={false}
        loop={false}
        freeMode={true}
        modules={[Autoplay, Pagination]}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        className="mySwiper h-12 mt-3"
      >
        {_mid3Banners?.map((banner: any, categoryidx: number) => {
          const link = banner?.link
          const webImage = banner?.url

          const mobileImage = banner?.mobileUrl
          const title = banner?.title

          const bannersData = {
            mid_banner_position: productIdx / 8,
            current_page: getCurrentPage() || '',
            position: categoryidx,
            banner_name: isMobileOnly
              ? mobileImage !== ''
                ? getImageNameFromURL(mobileImage)
                : getImageNameFromURL(webImage)
              : getImageNameFromURL(webImage),
            component_type: 'image',
            component_name:
              _mid3Banners?.length > 1 ? 'mid3-multiple' : 'mid3-single',
            loggedin_status: !!(user?.userId && user?.userId !== EmptyGuid),
            url: isMobileOnly
              ? mobileImage !== ''
                ? mobileImage
                : webImage
              : webImage,
            device: isMobileOnly ? 'Mobile' : 'Web',
          }

          return (
            <SwiperSlide
              key={`${categoryidx}`}
              onClick={() => handleBannerClickGAEvent(bannersData)}
            >
              <IntersectionObserverComponent
                title="PLP Mid Banners"
                eventName={GA_EVENT.BANNER_IMPRESSIONS}
                bannerData={bannersData}
              >
                <Link
                  legacyBehavior
                  href={`/${removePrecedingSlash(link)}`}
                  passHref
                >
                  <div className="relative flex flex-col w-full rounded">
                    <div className="relative flex-1">
                      {isMobileOnly ? (
                        <>
                          {mobileImage != '' ? (
                            <img
                              src={mobileImage || IMG_PLACEHOLDER}
                              style={{
                                width: '100%',
                              }}
                              alt={title || 'home banner'}
                              // className="h-56"
                            />
                          ) : (
                            <img
                              src={webImage || IMG_PLACEHOLDER}
                              alt={title || 'home banner'}
                            />
                          )}
                        </>
                      ) : (
                        <img
                          src={webImage || IMG_PLACEHOLDER}
                          alt={title || 'home banner'}
                        />
                      )}
                    </div>
                  </div>
                </Link>
              </IntersectionObserverComponent>
            </SwiperSlide>
          )
        })}
      </Swiper>
    )
  } else {
    return null
  }
}
